import { Injectable } from '@angular/core';

import { Maybe } from '@evc/web-components';

@Injectable({
  providedIn: 'root',
})
export class CellarService {
  public getValue(key: string): Maybe<string> {
    return localStorage.getItem(key) ?? undefined;
  }

  public setValue(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  public addValue(parent: string, key: string, value: unknown): void {
    const parentValue: Record<string, any> = JSON.parse(this.getValue(parent) ?? '{}');
    localStorage.setItem(parent, JSON.stringify({ ...parentValue, [key]: value }));
  }

  public clear(): void {
    localStorage.clear();
  }
}
